// Generator-discovered file route for the tests dashboard. Component lives in
// `src/ad/routes/tests.tsx` (Module K / K3).
import { createFileRoute } from '@tanstack/react-router';
import { TestsRouteComponent } from '@/ad/routes/tests';

export const Route = createFileRoute('/_authenticated/ad/tests')({
  component: TestsRouteComponent,
});
